export default __webpack_public_path__ + "96e96227e796e42f795575b4a313f0ad.png";